
/**

Messages shared with components.

*/
export const Messages = {
    // Error message displayed when a configuration name is required.
    add_config_new_configuration_name_required: 'Enter configuration name',

    // Error message displayed when the configuration name exceeds the maximum character limit.
    add_config_new_configuration_name_maxlength: 'Maximum length is 150 Characters only',

    // Error message displayed when an invalid configuration name is entered.
    add_config_new_configuration_name_invalid: 'Not a valid name',

    // Error message displayed when no workflow is selected during configuration creation.
    add_config_new_wf_validation: 'Choose at least one workflow',

    // Confirmation message displayed when confirming an update action.
    argument_card_confirmdialogmsg: 'Are you sure you want to update?',

    // Header text for the confirmation dialog.
    argument_card_confirmdialog_header: 'Update',

    // Placeholder text or label for the argument type selection field.
    argument_card_argtype: 'Choose argument type',

    // Success message displayed when an operation is successfully executed.
    que_mnger_expand_config_success_msg: 'Operation successful',

    // Error message displayed when an operation fails.
    que_mnger_expand_config_error_msg: 'Operation failed',

    // Success message displayed when the priority of a workflow is successfully updated.
    que_mnger_expand_config_priority_updated: 'Workflow priority updated successfully!',

    // Error message displayed when the priority update of a workflow fails.
    que_mnger_expand_config_priority_update_failed: 'Workflow priority failed to update!',

    // CSS class for displaying a high priority workflow.
    que_mnger_expand_config_priority_high: 'alert-danger',

    // CSS class for displaying a medium priority workflow.
    que_mnger_expand_config_priority_medium: 'alert-warning',

    // CSS class for displaying a low priority workflow.
    que_mnger_expand_config_priority_low: 'alert-success',

    // CSS class for displaying the default priority of a workflow.
    que_mnger_expand_config_priority_default: 'alert-info',

    // CSS class for displaying the queued status of a workflow.
    que_mnger_expand_config_status_queued: 'alert-warning',

    // CSS class for displaying the in-progress status of a workflow.
    que_mnger_expand_config_status_inprogress: 'alert-inprogress',

    // CSS class for displaying the default status of a workflow.
    que_mnger_expand_config_status_default: 'alert-info',

    // Error message displayed when a value is required between 0 and 100.
    table_editable_thresholdmsg_required: 'Enter value between 0-100',

    // Error message displayed when an invalid threshold value is entered.
    table_editable_thresholdmsg_thresholdvalue: 'Not a valid value',

    // Text or label for the refresh icon/button in an expandable table.
    table_expandable_refresh_icon: 'Refresh',

    // Title text for the confirmation dialog when editing an item.
    confirmdialog_edit_title: 'Edit',

    // Title text for the confirmation dialog when deleting an item.
    confirmdialog_delete_title: 'Delete',

    confirmdialog_active_links_exists: 'Active links exist',

    // Confirmation message displayed when confirming an edit action.
    confirmdialog_edit_msg: 'Are you sure you want to update?',

    // Confirmation message displayed when confirming an edit action.
    confirmdialog_edit_msg_link: 'Are you sure you want to update the link details?',

    // Confirmation message displayed when confirming a delete action.
    confirmdialog_delete_msg: 'Are you sure you want to delete this?',

    // Confirmation message displayed when confirming a delete action.
    confirmdialog_delete_msg_link: 'Are you sure you want to delete this link?',

    confirmdialog_delete_msg_active_link: 'Are you sure you want to override existing active link?',

    trigger_artifact_repo_required: 'Enter a repo name',

    trigger_artifact_repo_invalid: 'Not a valid repo name',

    trigger_artifact_input_outputrepo_required: 'You must enter a value',

    trigger_artifact_input_outputrepo_invalid: 'Not a valid URL',

    no_data: 'No data available',
    no_records: 'No reocords found',
    no_selected_item: 'Select an execution to view the data',
    no_cards: 'No active links available',

    tools_thresholds_no_data: 'No tools associated with the selected workflow',

    areYouSure: 'Are you sure?',
    abortJobSurety: "Do you really want to abort this workflow job?",
    token_expiry_msg: 'Your session has been expired. Please log in again to continue.',
    emptyList: 'No results found. Please try a different search term.',
    permissionMsg: 'You do not have the necessary permissions to perform this action',
    noLink: 'Link not available',
    
    // Workflow Run error message
    workflow_run_http_error: 'HTTP error occurred while loading workflow data',
};